import type { RedcatAnalyticsStore } from '../types/store';
import { SigninTrackEventName } from '../types/signin';
import type { SignupMethod } from '../types/signup';
import type { SigninTrackEvent } from '../types/events/track';

export const trackSigninSucceeded = (
  track: RedcatAnalyticsStore['track'],
  { loginMethod }: { loginMethod: SignupMethod },
) => {
  const event: SigninTrackEvent = {
    name: SigninTrackEventName.Succeeded,
    properties: {
      login_method: loginMethod,
    },
  };

  track(event);
};
